export default __webpack_public_path__ + "static/media/ColorButton.bf562059.svg";